// extracted by mini-css-extract-plugin
export const container = "galleryTemplate-module--container--15Pfe";
export const column = "galleryTemplate-module--column--2Paew";
export const image = "galleryTemplate-module--image--3YoTh";